import React from "react";
import chesssboard from "../../images/chesssboard.png";
import chessslogo from "../../images/chessslogo.png";

function NewsSummary() {
  return (
   
            <div className="" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>  
              <div style={{ 
          color: 'gold', 
          fontSize: '24px', 
          fontWeight: 'bold', 
          textAlign: 'center', 
          padding: '4px', 
          borderBottom: '2px solid gold',
          marginBottom: '20px'
        }}>S T A R T&nbsp;&nbsp;&nbsp;H E R E</div>
              <div style={{ 
          color: 'white', 
          width: '100%', 
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start', // Align list items properly
          justifyContent: 'center',
          marginLeft: '15px',
          gap: '5px'
        }}>
              <li>Scroll For More Chess</li>
              <li>Sort By Tags & Difficulty</li>
              <li>Click To Expand</li>
              <li>Play Any Puzzle</li>
              </div>
              <img src={chessslogo} alt="Chess Logo" style={{ width: '130px', height: '130px', marginTop: 'auto', marginBottom: '10px' }} />
              <button 
                className="trending-cta-2" 
                style={{ 
                  background: '', 
                  lineHeight: '1.5', 
                  marginTop: 'auto', 
                  marginBottom: '10px', 
                  width: '90%', 
                  height: '100px', 
                  padding: '10px', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  border: '3px solid gold',
                  color: 'gold',
                  backgroundColor: 'black'
                }}
                onClick={() => {
                  window.location.href = '/analysis';
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = 'gold';
                  e.currentTarget.style.borderColor = 'gold';
                  e.currentTarget.style.color = 'black';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'black';
                  e.currentTarget.style.borderColor = 'gold';
                  e.currentTarget.style.color = 'gold';
                }}
              >CREATE <br />CHESS<br />CONTENT</button>
        </div>
  );
}

export default NewsSummary;